import { render } from "./BlockDoctorWord.vue?vue&type=template&id=2af1634a&scoped=true"
import script from "./BlockDoctorWord.vue?vue&type=script&lang=js"
export * from "./BlockDoctorWord.vue?vue&type=script&lang=js"

import "./BlockDoctorWord.vue?vue&type=style&index=0&id=2af1634a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af1634a"]])

export default __exports__